module.exports = __webpack_public_path__ + "static/img/18003D_1_C_20210222_LC.d9e79e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18003D_1_C_20210222_LC.png
// module id = i8Y1
// module chunks = 0